module.exports = __webpack_public_path__ + "media/educator_link_to_fastweb/fastweb-logo_250x70-e12366cb.png";